import {
  styled,
  TableCell,
  TableContainer,
  Typography,
  type SxProps,
  type TableCellProps,
  type Theme,
} from "@mui/material";

import theme from "@/theme";

export const HeaderCell = styled(TableCell)(() => ({
  backgroundColor: theme.palette.background["paper-elevation-1"],
  border: 0,
  borderRight: "2px solid white",
  "&:last-child": { borderRight: 0 },
}));

export const RowCell = styled(TableCell)(() => ({
  border: 0,
  borderRight: "2px solid white",
  "&:last-child": { borderRight: 0 },
}));

export const AudienceTableContainer = styled(TableContainer)(() => ({
  overflow: "hidden",
  overflowY: "auto",
  borderRadius: theme.spacing(3),
}));

const truncatedCellSx: SxProps<Theme> = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: 0,
};

export interface TruncatedRowCellProps extends TableCellProps {
  children: React.ReactNode;
}

export function TruncatedRowCell({
  children,
  sx,
  ...props
}: TruncatedRowCellProps) {
  return (
    <RowCell
      sx={sx ? [truncatedCellSx, sx].flat() : truncatedCellSx}
      {...props}
    >
      <Typography
        component="div"
        variant="body2"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {children}
      </Typography>
    </RowCell>
  );
}
